import { clearSection }                from "dmpconnectjsapp-base/actions";
import commands                        from "dmpconnectjsapp-base/actions/config/commands";
import { apiSections }                 from "dmpconnectjsapp-base/constants";
import { isLoading }                   from "dmpconnectjsapp-base/helpers/common";
import moment                          from "moment";
import PropTypes                       from "prop-types";
import React, { useEffect, useState }  from "react";
import { AsyncTypeahead, Highlighter } from "react-bootstrap-typeahead";
import { connect }                     from "react-redux";
import { getAction }                   from "../../../dmpconnect/actions";

const AsyncInseeCog = ({
  dispatch,
  onChange,
  isInvalid,
  id,
  name,
  value,
  codes,
  loading,
  disabled
}) => {
  const [search, setSearch] = useState("");
  
  useEffect(() => {
    const timeoutId = setTimeout(async () => {
      if (search) {
        dispatch(clearSection(apiSections.GET_COG_CITY_CODES));
        dispatch(clearSection(apiSections.GET_COG_COUNTRY_CODES));
        dispatch(getAction(
          commands.getCogCityCodes,
          apiSections.GET_COG_CITY_CODES,
          { s_name: `%${search}%` }
        ));
        dispatch(getAction(
          commands.getCogCountryCodes,
          apiSections.GET_COG_COUNTRY_CODES,
          { s_name: `%${search}%` }
        ));
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [search]);
  
  const searchCogs = (query) => {
    if (query.trim().length >= 1) {
      setSearch(query);
    }
  };
  
  return (
    <>
      <AsyncTypeahead
        disabled={disabled}
        className="custom-typeahead"
        id={id}
        name={name}
        isLoading={loading}
        labelKey={"s_name"}
        valueKey={"s_code"}
        onSearch={searchCogs}
        options={codes}
        placeholder="Rechercher une ville ou un pays"
        searchText="Recherche en cours ..."
        emptyLabel="Aucun résultat"
        isInvalid={isInvalid}
        onChange={(selection) => {
          onChange(selection[0]);
        }}
        onInputChange={(text) => {
          if (text === "") {
            onChange("");
          }
        }}
        defaultInputValue={value}
        renderMenuItemChildren={(option) => (
          <div className="d-flex flex-column mss-recipients">
            <div>
              <Highlighter search={search}>
                {option.s_name}
              </Highlighter>
            </div>
            {option.type === "Pays" && (
              <div className="mss-recipient-email">
                <small className="text-gray-400">
                  {option.s_officialName}
                </small>
              </div>
            )}
            <div className="mss-recipient-email">
              <small className="text-gray-400">
                {`${option.type} - entre ${moment(option.s_startDate, "YYYY-MM-DD").format("DD/MM/YYYY")} et ${option.s_endDate ? moment(option.s_endDate, "YYYY-MM-DD").format("DD/MM/YYYY") : "maintenant"}`}
              </small>
            </div>
          </div>
        )}
      />
    </>
  );
};

AsyncInseeCog.propTypes = {
  dispatch : PropTypes.func.isRequired,
  onChange : PropTypes.func.isRequired,
  id       : PropTypes.string.isRequired,
  name     : PropTypes.string.isRequired,
  isInvalid: PropTypes.bool,
  loading  : PropTypes.bool,
  disabled : PropTypes.bool,
  codes    : PropTypes.array
};

AsyncInseeCog.defaultProps = {
  isInvalid: false,
  loading  : false,
  disabled : false,
  codes    : []
};

function mapStateToProps (state) {
  const {
          dmpconnect: {
            [apiSections.GET_COG_CITY_CODES]   : getCogCityCodes,
            [apiSections.GET_COG_COUNTRY_CODES]: getCogCountryCodes
          }
        } = state;
  
  const cities    = (getCogCityCodes.Cities || []).map(city => ({ ...city, type: "Ville" }));
  const countries = (getCogCountryCodes.Countries || []).map(country => ({ ...country, type: "Pays" }));
  return {
    codes  : [...countries, ...cities],
    loading: isLoading(getCogCityCodes) || isLoading(getCogCountryCodes)
  };
}

export default connect(mapStateToProps)(AsyncInseeCog);
